import { createSelector } from '@reduxjs/toolkit';

const getKarmaEarnEntity = ({ karmaEarnList }) => karmaEarnList;

export const genresSelector = createSelector(getKarmaEarnEntity, ({ genres }) => genres);
export const deviceTypesSelector = createSelector(getKarmaEarnEntity, ({ deviceTypes }) => deviceTypes);
export const isMyOffersSelector = createSelector(getKarmaEarnEntity, ({ isMyOffers }) => isMyOffers);
export const isVpnDetectedSelector = createSelector(getKarmaEarnEntity, ({ isVpnDetected }) => isVpnDetected);
export const offerTypeSelector = createSelector(getKarmaEarnEntity, ({ offerType }) => offerType);
export const pageSelector = createSelector(getKarmaEarnEntity, ({ page }) => page);
export const isLoadedSelector = createSelector(getKarmaEarnEntity, ({ isLoaded }) => isLoaded);
export const isLoadingSelector = createSelector(getKarmaEarnEntity, ({ isLoading }) => isLoading);
export const isLastPageSelector = createSelector(getKarmaEarnEntity, ({ isLastPage }) => isLastPage);
export const karmaEarnItemsSelector = createSelector(getKarmaEarnEntity, ({ karmaEarnItems }) => karmaEarnItems);
